import Vue from 'vue'
import AppError from '../../components/AppError'
import AppRequiredLabel from '../../components/AppRequiredLabel'
import AppDatetimeSelect from '../../components/AppDatetimeSelect'
import AppWarekiDateSelect from '../../components/AppWarekiDateSelect'
import {sprintf} from 'sprintf-js'

Vue.component("app-error", AppError)
Vue.component("app-required-label", AppRequiredLabel)
Vue.component("app-datetime-select", AppDatetimeSelect)
Vue.component("app-wareki-date-select", AppWarekiDateSelect)

function setErrorClassToForm(errorKeys) {
  if (errorKeys && errorKeys.length > 0) {
    errorKeys.map((v) => {
      const nodeList = document.querySelectorAll('input[name='+v+'],textarea[name='+v+'],select[name='+v+']')
      if (nodeList) {
        for (let form of nodeList) {
          form.classList.add("error")
        }
      }
    })
  }
}

function scrollToFirstError() {
  const el = document.querySelector('.error')
  if (el) {
    el.scrollIntoView()
  }
}

export default (data) => {
  const vm = new Vue({
    el: '#accident-report-form',
    data: data,
    methods: {
      accidentSummaryImageNo($value) {
        return sprintf('%02d', $value)
      }
    },
    computed: {
      otherRequired() {
        for(let i in this.form.taijin_taibutsu) {
          if (this.constants.TAIJIN_TAIBUTSU_TAIJIN == this.form.taijin_taibutsu[i]) {
            return true
          }
        }
        return false
      },
      otherFushoDetailRequired() {
        return this.otherRequired && (this.form.other_fusho === "1");
      }
    },
    mounted: function() {
      setErrorClassToForm(this.errors)
      scrollToFirstError()
    }
  })
}
